import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';
import i18n from 'i18n';

export const SCRIPT_REQUEST_RESET = '@SCRIPT_REQUEST/RESET';
export const SCRIPT_REQUEST_CHANGE_FILTER = '@SCRIPT_REQUEST/CHANGE_FILTER';
export const SCRIPT_REQUEST_APPLY_PRINT_OPTIONS = '@SCRIPT_REQUEST/APPLY_PRINT_OPTIONS';
export const SCRIPT_REQUEST_PRINT_REQUEST = '@SCRIPT_REQUEST/PRINT_REQUEST';
export const SCRIPT_REQUEST_PRINT_REQUEST_SUCCESS = '@SCRIPT_REQUEST/PRINT_REQUEST_SUCCESS';
export const SCRIPT_REQUEST_PRINT_REQUEST_FAIL = '@SCRIPT_REQUEST/PRINT_REQUEST_FAIL';
export const SCRIPT_REQUEST_CLEAR_HISTORY_FILE = '@SCRIPT_REQUEST/CLEAR_HISTORY_FILE';

export const SCRIPT_REQUEST_SENDEMAIL_REQUEST = '@SCRIPT_REQUEST/SENDEMAIL_REQUEST';
export const SCRIPT_REQUEST_SENDEMAIL_REQUEST_SUCCESS = '@SCRIPT_REQUEST/SENDEMAIL_REQUEST_SUCCESS';
export const SCRIPT_REQUEST_SENDEMAIL_REQUEST_FAIL = '@SCRIPT_REQUEST/SENDEMAIL_REQUEST_FAIL';

export const SCRIPT_REQUEST_CHANGE_RANDOM = '@SCRIPT_REQUEST/CHANGE_RANDOM';
export const SCRIPT_REQUEST_CLEAR_FILTER = '@SCRIPT_REQUEST/CLEAR_FILTER';
export const SCRIPT_REQUEST_CACHE_SCRIPT_LIST_ITEMS = '@SCRIPT_REQUEST/CACHE_SCRIPT_LIST_ITEMS';

const validateScriptRequestEmailSelection = (includedIds, scriptItemsById) => {
  const doctorsWithoutEmail = [];
  let hasEligible = false;
  let uncoveredCount = 0;

  includedIds.forEach((id) => {
    const item = scriptItemsById[id];
    if (!item) {
      uncoveredCount += 1;
      return;
    }

    const doctorName = (item.doctorName || '').trim();
    const doctorEmail = (item.doctorEmail || '').trim();

    if (doctorName && doctorEmail) {
      hasEligible = true;
    } else if (doctorName && !doctorEmail && !doctorsWithoutEmail.includes(doctorName)) {
      doctorsWithoutEmail.push(doctorName);
    }
  });

  if (doctorsWithoutEmail.length) {
    return { isValid: false, doctorsWithoutEmail };
  }

  const allCovered = uncoveredCount === 0;
  if (allCovered) {
    const allValid = includedIds.every((id) => {
      const item = scriptItemsById[id];
      const doctorName = (item?.doctorName || '').trim();
      const doctorEmail = (item?.doctorEmail || '').trim();
      return doctorName && doctorEmail;
    });

    if (!allValid || !hasEligible) {
      return { isValid: false, messageKey: 'EMAIL_NO_ELIGIBLE_SCRIPTS' };
    }
  }

  return { isValid: true };
};

const formatDoctorMissingEmailMessage = (doctorNames) => {
  const intro = i18n.t('scriptRequest:EMAIL_DOCTOR_MISSING_INTRO');
  const doctorLines = (doctorNames || []).map((name) => `- ${name}`).join('\n');
  return doctorLines ? `${intro}\n${doctorLines}` : intro;
};

export const SCRIPT_REQUEST_GET_INCLUDE_VPB = '@SCRIPT_REQUEST/GET_INCLUDE_VPB';
export const SCRIPT_REQUEST_GET_INCLUDE_VPB_SUCCESS = '@SCRIPT_REQUEST/GET_INCLUDE_VPB_SUCCESS';
export const SCRIPT_REQUEST_GET_INCLUDE_VPB_FAIL = '@SCRIPT_REQUEST/GET_INCLUDE_VPB_FAIL';

export const SCRIPT_REQUEST_UPDATE_INCLUDE_VPB = '@SCRIPT_REQUEST/UPDATE_INCLUDE_VPB';
export const SCRIPT_REQUEST_UPDATE_INCLUDE_VPB_SUCCESS = '@SCRIPT_REQUEST/UPDATE_INCLUDE_VPB_SUCCESS';
export const SCRIPT_REQUEST_UPDATE_INCLUDE_VPB_FAIL = '@SCRIPT_REQUEST/UPDATE_INCLUDE_VPB_FAIL';

export const SCRIPT_REQUEST_GET_PRINT_OPTIONS = '@SCRIPT_REQUEST/GET_PRINT_OPTIONS';
export const SCRIPT_REQUEST_GET_PRINT_OPTIONS_SUCCESS = '@SCRIPT_REQUEST/GET_PRINT_OPTIONS_SUCCESS';
export const SCRIPT_REQUEST_GET_PRINT_OPTIONS_FAIL = '@SCRIPT_REQUEST/GET_PRINT_OPTIONS_FAIL';

export const SCRIPT_REQUEST_SAVE_PRINT_OPTIONS = '@SCRIPT_REQUEST/SAVE_PRINT_OPTIONS';
export const SCRIPT_REQUEST_SAVE_PRINT_OPTIONS_SUCCESS = '@SCRIPT_REQUEST/SAVE_PRINT_OPTIONS_SUCCESS';
export const SCRIPT_REQUEST_SAVE_PRINT_OPTIONS_FAIL = '@SCRIPT_REQUEST/SAVE_PRINT_OPTIONS_FAIL';

export const getIncludeVPB = () => {
  return (dispatch, getState) => {
    const { currentPharmacyId: pharmacyId } = getState().auth.user.data;
    dispatch({ type: SCRIPT_REQUEST_GET_INCLUDE_VPB });
    HttpService.get(`/api/pharmacies/${pharmacyId}/include-vpb`)
      .then((res) => {
        dispatch({ type: SCRIPT_REQUEST_GET_INCLUDE_VPB_SUCCESS, payload: res?.data?.isIncludeVPB });
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: SCRIPT_REQUEST_GET_INCLUDE_VPB_FAIL });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const updateIncludeVPB = (data) => {
  return (dispatch, getState) => {
    const { currentPharmacyId: pharmacyId } = getState().auth.user.data;
    dispatch({ type: SCRIPT_REQUEST_UPDATE_INCLUDE_VPB });
    HttpService.put(`/api/pharmacies/${pharmacyId}/include-vpb`, { isIncludeVPB: data })
      .then(() => {
        dispatch({ type: SCRIPT_REQUEST_UPDATE_INCLUDE_VPB_SUCCESS, payload: data });
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: SCRIPT_REQUEST_UPDATE_INCLUDE_VPB_FAIL });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const resetData = () => {
  return (dispatch) => {
    dispatch({ type: SCRIPT_REQUEST_RESET });
  };
};

export const changeFilter = (filter) => {
  return (dispatch) => {
    dispatch({ type: SCRIPT_REQUEST_CHANGE_FILTER, payload: filter });
  };
};

export const clearFilter = () => {
  return (dispatch) => {
    dispatch({ type: SCRIPT_REQUEST_CLEAR_FILTER });
  };
};

export const changeRandom = () => {
  return (dispatch) => {
    dispatch({ type: SCRIPT_REQUEST_CHANGE_RANDOM });
  };
};

export const cacheScriptListItems = (items) => ({
  type: SCRIPT_REQUEST_CACHE_SCRIPT_LIST_ITEMS,
  payload: items,
});

export const applyPrintOptions = (options) => {
  return (dispatch) => {
    dispatch({ type: SCRIPT_REQUEST_APPLY_PRINT_OPTIONS, payload: options });
  };
};

export const getPrintOptions = () => {
  return (dispatch, getState) => {
    const { currentPharmacyId: pharmacyId } = getState().auth.user.data;
    dispatch({ type: SCRIPT_REQUEST_GET_PRINT_OPTIONS });
    HttpService.get(`/api/pharmacies/${pharmacyId}/script-request-print-options`)
      .then((res) => {
        const printOptions = res?.data || {};
        dispatch({ type: SCRIPT_REQUEST_GET_PRINT_OPTIONS_SUCCESS, payload: printOptions });
        // Also apply the options to the current state
        dispatch({ type: SCRIPT_REQUEST_APPLY_PRINT_OPTIONS, payload: printOptions });
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: SCRIPT_REQUEST_GET_PRINT_OPTIONS_FAIL });
        // Don't show error if endpoint doesn't exist yet (404), just use defaults
        if (err?.response?.status !== 404) {
          dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
        }
      });
  };
};

export const savePrintOptions = (options) => {
  return (dispatch, getState) => {
    const { currentPharmacyId: pharmacyId } = getState().auth.user.data;
    dispatch({ type: SCRIPT_REQUEST_SAVE_PRINT_OPTIONS });
    HttpService.put(`/api/pharmacies/${pharmacyId}/script-request-print-options`, options)
      .then(() => {
        dispatch({ type: SCRIPT_REQUEST_SAVE_PRINT_OPTIONS_SUCCESS, payload: options });
        // Also apply the options to the current state
        dispatch({ type: SCRIPT_REQUEST_APPLY_PRINT_OPTIONS, payload: options });
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: SCRIPT_REQUEST_SAVE_PRINT_OPTIONS_FAIL });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const printRequest = () => {
  return async (dispatch, getState) => {
    const {
      filter: {
        patientGroupIds,
        doctorIds,
        patientIds,
        weekNumber,
        repeatsLeft,
        includeSuspendedPatient,
        isShowPacked,
        isShowNonPacked,
        isShowPackedPRN,
        isShowCeasedDeletedMed,
      },
      printOptions: { isPrintPerPatient, isIncludeMedicationDetails, isRepeatsRemaining, includedIds, excludedIds },
    } = getState().scriptRequest.list;
    dispatch({ type: SCRIPT_REQUEST_PRINT_REQUEST });
    try {
      const res = await HttpService.post('/api/script-request/export', {
        patientGroupIds,
        doctorIds,
        patientIds,
        weekNumber,
        repeatsLeft,
        includeSuspendedPatient,
        isShowPacked,
        isShowNonPacked,
        isShowPackedPRN,
        isShowCeasedDeletedMed,
        isPrintPerPatient,
        isIncludeMedicationDetails,
        isRepeatsRemaining,
        includedIds,
        excludedIds,
      });
      dispatch({
        type: SCRIPT_REQUEST_PRINT_REQUEST_SUCCESS,
        payload: { fileName: res.data.fileName, fileUrl: res.data.fileUrl },
      });
    } catch (err) {
      const { errorMessages, errorTitle } = parseError(err);
      dispatch({ type: SCRIPT_REQUEST_PRINT_REQUEST_FAIL });
      dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
    }
  };
};

export const emailRequest = () => {
  return async (dispatch, getState) => {
    const {
      filter: {
        patientGroupIds,
        doctorIds,
        patientIds,
        weekNumber,
        repeatsLeft,
        includeSuspendedPatient,
        includeVPB,
        isShowPacked,
        isShowNonPacked,
        isShowPackedPRN,
        isShowCeasedDeletedMed,
      },
      printOptions: { isPrintPerPatient, isIncludeMedicationDetails, isRepeatsRemaining, includedIds, excludedIds },
    } = getState().scriptRequest.list;

    if (!includedIds?.length) {
      dispatch(
        AppActions.createDialogMessage('error', 'scriptRequest:EMAIL_NO_SELECTION_TITLE', [
          i18n.t('scriptRequest:EMAIL_NO_SELECTION_MESSAGE'),
        ]),
      );
      return;
    }

    const { scriptItemsById } = getState().scriptRequest.list;
    const validation = validateScriptRequestEmailSelection(includedIds, scriptItemsById || {});
    if (!validation.isValid) {
      if (validation.doctorsWithoutEmail?.length) {
        dispatch(
          AppActions.createDialogMessage('error', 'scriptRequest:EMAIL_DOCTOR_MISSING_TITLE', [
            formatDoctorMissingEmailMessage(validation.doctorsWithoutEmail),
          ]),
        );
        return;
      }
      if (validation.messageKey) {
        dispatch(
          AppActions.createDialogMessage('error', 'scriptRequest:EMAIL_DOCTOR_MISSING_TITLE', [
            i18n.t(`scriptRequest:${validation.messageKey}`),
          ]),
        );
        return;
      }
    }

    const payload = {
      patientGroupIds,
      doctorIds,
      patientIds,
      weekNumber,
      repeatsLeft,
      includeSuspendedPatient,
      includeVPB,
      isShowPacked,
      isShowNonPacked,
      isShowPackedPRN,
      isShowCeasedDeletedMed,
      isPrintPerPatient,
      isIncludeMedicationDetails,
      isRepeatsRemaining,
      includedIds,
      excludedIds,
    };

    dispatch({ type: SCRIPT_REQUEST_SENDEMAIL_REQUEST });
    try {
      const res = await HttpService.post('/api/script-request/sendemail', payload);
      if (res != null && res.isSuccess === false) {
        dispatch({ type: SCRIPT_REQUEST_SENDEMAIL_REQUEST_FAIL });
        const doctors = res?.doctorsWithoutEmail || [];
        if (doctors.length) {
          dispatch(
            AppActions.createDialogMessage('error', 'scriptRequest:EMAIL_DOCTOR_MISSING_TITLE', [
              formatDoctorMissingEmailMessage(doctors),
            ]),
          );
        } else if (res?.message) {
          dispatch(AppActions.createDialogMessage('error', 'scriptRequest:EMAIL_DOCTOR_MISSING_TITLE', [res.message]));
        } else {
          dispatch(
            AppActions.showMessage({
              message: 'scriptRequest:EMAIL_REQUEST_FAIL',
              variant: 'error',
            }),
          );
        }
        return;
      }
      dispatch({ type: SCRIPT_REQUEST_SENDEMAIL_REQUEST_SUCCESS });
      dispatch(
        AppActions.showMessage({
          message: 'scriptRequest:EMAIL_REQUEST_SUCCESS',
        }),
      );
    } catch (err) {
      const { errorMessages } = parseError(err);
      dispatch({ type: SCRIPT_REQUEST_SENDEMAIL_REQUEST_FAIL });
      dispatch(
        AppActions.showMessage({
          message: errorMessages.join('\n'),
          variant: 'error',
        }),
      );
    }
  };
};

export const clearHistoryFile = () => {
  return (dispatch) => {
    dispatch({ type: SCRIPT_REQUEST_CLEAR_HISTORY_FILE });
  };
};
